import { useEffect } from 'react'
import type { ReactNode } from 'react'
import { usePage } from '@inertiajs/react'
import MarketingFooter from '@/components/marketing/MarketingFooter'
import MetaTags from '@/components/marketing/MetaTags'
import MarketingNav from '@/components/marketing/MarketingNav'
import CookieConsentBanner from '@/components/marketing/CookieConsentBanner'
import ServiceNoticeBanner from '@/components/ServiceNoticeBanner'
import type { SharedMarketingProps } from '@/types/marketing'
import { installAnalytics } from '@/lib/analytics'

export default function MarketingLayout({ children }: { children: ReactNode }) {
  const { props } = usePage<SharedMarketingProps>()
  const layout = props.layout

  useEffect(() => {
    installAnalytics(layout?.analytics)
  }, [layout?.analytics])

  return (
    <>
      <MetaTags />
      <div className="marketing-shell">
        <div className="marketing-page-glow marketing-page-glow-top" aria-hidden="true" />
        <div className="marketing-page-glow marketing-page-glow-bottom" aria-hidden="true" />
        <div className="marketing-grid-overlay" aria-hidden="true" />
        <MarketingNav layout={layout} />
        <main className="relative z-10">{children}</main>
        <MarketingFooter layout={layout} />
        <CookieConsentBanner />
        {/* Service notices (e.g. a maintenance banner) float at the bottom so
            they stay visible without being hidden behind the fixed navbar, and
            users can dismiss them. Sits above the cookie bar. */}
        {(layout?.service_notices?.length ?? 0) > 0 && (
          <div className="pointer-events-none fixed inset-x-0 bottom-0 z-[60] px-4 pb-4 sm:px-6">
            <div className="pointer-events-auto mx-auto w-full max-w-3xl">
              <ServiceNoticeBanner notices={layout.service_notices!} />
            </div>
          </div>
        )}
      </div>
    </>
  )
}
